import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { tap } from 'rxjs/operators';

import { ReportDetailsService } from '../report.details.service';

import { Report } from '../report';
import { reportGroup } from '../report.group';
import { ScheduleReportService } from '../schedule-report/schedule-report.service';

@Component({
   selector: 'lib-reports-display',
   templateUrl: './display.component.html',
   styleUrls: ['./display.component.scss'],
   inputs: [ 'action', 'report' ],
})
export class DisplayComponent implements OnInit {

   action = 'new';
   report: Report = new Report();

   get reportForm() { return this.reportDetails.reportForm; }

   _delete = false;
   _saving = false;
   hintOpen = false;

   constructor(
      private router: Router,
      private reportDetails: ReportDetailsService,
      public scheduleReport: ScheduleReportService,
   ) { }

   ngOnInit() {
      if ( document.scrollingElement ) {
         document.scrollingElement.scrollTop = 0;
      }

      this.reportDetails.reportForm = reportGroup( this.report );
   }

   save() {
      this._saving = true;

      if(this.reportForm.get('name')?.value){
         this.reportForm.get('name')?.setValue(this.reportForm.get('name').value.replace(/\s{2,}/g, ' ').trim());
      }

      this.reportDetails.save().pipe(
         tap( _ => this._saving = false ),
      ).subscribe( _ => this.router.navigate([ '/report' ]));
   }

   run() {
      this.reportDetails.reportId$.next(null);
      if ( this.reportDetails.reportForm.get( 'name' ).value ) {
         this.reportDetails.save().subscribe();
      }
      this.reportDetails.reportId$.subscribe(newReportId=> {
         const id = this.reportDetails.reportForm.get( 'id' ).value;
         this.router.navigate([ `report/run`, id || newReportId || '' ]);
      });
   }

   delete() {
      this.reportDetails.delete( this.reportDetails.reportForm.get( 'id' ).value )
         .subscribe( _ => this.router.navigate([ '/report' ]));
   }

   schedule(){
      const id = this.reportDetails.reportForm.get( 'id' ).value;
      const name = this.reportDetails.reportForm.get( 'name' ).value;
      this.scheduleReport.reportName$.next(name);
      this.router.navigate([ `report/schedule`, id || '' ]);
      // this.router.navigate([ `/report/schedule` ]);
   }
}
